<div class="main-container">
  @if (!isAddCustomer) {
    <div [formGroup]="addCustomerForm">
      <div class="page-header">
        <div class="routing-buttons">
          <div
            class="action-button back-button"
            (click)="navigateBack()"
            tabindex="0"
            (keydown.enter)="navigateBack()"
          >
            <mat-icon class="icon back-icon">arrow_back</mat-icon>
          </div>
          <div
            class="action-button reload-button"
            (click)="ngOnInit()"
            tabindex="0"
            (keydown.enter)="ngOnInit()"
          >
            <mat-icon class="icon reload-icon">refresh</mat-icon>
          </div>
          <span class="page-title">Customer Management</span>
        </div>
        <!-- Redirect Button -->
        @if (customerPermissionCreate) {
          <div class="button-group">
            <button class="primary-button" (click)="addCustomer('add')">
              Add Customer <mat-icon class="btn-icon">open_in_new</mat-icon>
            </button>
          </div>
        }
      </div>

      @if (customerPermissionView) {
        <div class="component-container">
          <!-- Component Header Section -->
          <div class="component-header">
            <h6 class="component-title">Customer List</h6>
            <div class="component-actions">
              <app-common-search
                (searchSubmit)="onSearchCustomersName($event)"
              ></app-common-search>
            </div>
          </div>

          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>

          <!-- Component Body Section -->
          <div class="component-body">
            <table>
              <thead>
                <tr>
                  <th>Customer Name</th>
                  <th>Created At</th>
                  <th>Action</th>
                </tr>
              </thead>
              @if (customerList.length > 0) {
                <tbody>
                  @for (item of customerList; track item) {
                    <tr>
                      <td>
                        {{ item.customerName }}
                      </td>
                      <td>
                        {{ item.createdAt | date: 'dd/MM/yyyy' }}
                      </td>
                      <td>
                        <div class="action-buttons">
                          @if (customerPermissionUpdate) {
                            <button
                              class="primary-button view-button"
                              (click)="fetchCustomerById(item.id)"
                            >
                              <mat-icon class="btn-icon">visibility</mat-icon>
                            </button>
                          }
                          @if (customerPermissionDelete) {
                            <button
                              class="primary-button delete-button"
                              (click)="deleteCustomer(item.id)"
                            >
                              <mat-icon class="btn-icon">delete</mat-icon>
                            </button>
                          }
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              }
              @if (customerList.length === 0) {
                <tbody>
                  <tr>
                    <td colspan="12">
                      <img
                        loading="lazy"
                        class="no-data-img"
                        src="../../assets/dataNotFound.jpg"
                        alt="nodatafound"
                      />
                    </td>
                  </tr>
                </tbody>
              }
            </table>
          </div>

          <!-- Separator between Body and Footer -->
          <div class="component-separator"></div>

          <div class="component-footer">
            @if (customerList.length > 0) {
              <app-common-component-pagination
                [totalItems]="totalItems"
                [pageSize]="pageSize"
                [currentPage]="pageNo"
                (pageChange)="onPageChange($event)"
                (sizeChange)="onSizeChange($event)"
              >
              </app-common-component-pagination>
            }
          </div>
        </div>
      }
    </div>
  }

  @if (isAddCustomer) {
    <div>
      <form [formGroup]="addCustomerForm" novalidate>
        <div class="page-header">
          <div class="routing-buttons">
            <div
              class="action-button back-button"
              (click)="changePage()"
              tabindex="0"
              (keydown.enter)="changePage()"
            >
              <mat-icon class="icon back-icon">arrow_back</mat-icon>
            </div>
            <div
              class="action-button reload-button"
              (click)="onClickAddCustomerRefresh()"
              tabindex="0"
              (keydown.enter)="onClickAddCustomerRefresh()"
            >
              <mat-icon class="icon reload-icon">refresh</mat-icon>
            </div>
            <span class="page-title">Customer Management</span>
          </div>
        </div>

        <div class="component-container">
          <div class="component-header">
            @if (isCustomerAddForm) {
              <h6 class="component-title">Add Customer</h6>
            }
            @if (!isCustomerAddForm) {
              <h6 class="component-title">Update Customer</h6>
            }
            <div class="component-actions"></div>
          </div>

          <!-- Separator between Header and Body -->
          <div class="component-separator"></div>

          @if (customerPermissionView) {
            <div class="component-body">
              <div class="form-section">
                <div class="form-group">
                  <label for="customerName" class="form-label"
                    >Customer Name</label
                  >
                  <mat-form-field appearance="outline">
                    <mat-label>Customer Name</mat-label>
                    <input
                      matInput
                      id="customerName"
                      type="text"
                      placeholder="Customer Name"
                      formControlName="customerName"
                      required
                    />
                    @if (
                      addCustomerForm.controls['customerName'].touched &&
                      addCustomerForm.controls['customerName'].errors
                        ?.requiredAndNoEmptySpaces
                    ) {
                      <mat-error>
                        {{
                          addCustomerForm.controls['customerName'].errors
                            ?.requiredAndNoEmptySpaces
                        }}
                      </mat-error>
                    }
                    @if (
                      addCustomerForm.controls['customerName'].touched &&
                      addCustomerForm.controls['customerName'].errors
                        ?.nonNumericNoSpecialChars
                    ) {
                      <mat-error>
                        {{
                          addCustomerForm.controls['customerName'].errors
                            ?.nonNumericNoSpecialChars
                        }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>
          }

          <!-- Separator between Body and Footer -->
          <div class="component-separator"></div>

          <div class="component-footer">
            <div class="button-group right mb-2">
              @if (isCustomerAddForm && customerPermissionCreate) {
                <button
                  class="submit-button"
                  (click)="saveCustomer()"
                  [disabled]="this.addCustomerForm.invalid"
                >
                  Submit<mat-icon class="btn-icon">check_circle</mat-icon>
                </button>
              }
              @if (!isCustomerAddForm && customerPermissionUpdate) {
                <button class="edit-button" (click)="updateCustomer()">
                  Update <mat-icon class="btn-icon">edit</mat-icon>
                </button>
              }
            </div>
          </div>
        </div>
      </form>
    </div>
  }
</div>
